import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import {
  Wrapper,
  GridContainer,
  LoaderContainer,
  RightSection
} from './styled';
import Topic from '../topic';
import PulseLoader from '../pulse-loader';
import EmptyState from '../empty-state';
import { UPDATE_SELECTED_ACTIVITIES } from '../../containers/course-assign/course-assign-types';

const Topics = (props) => {
  const showGridLoader = useSelector(
    (state) => state.CourseAssignReducer.showGridLoader
  );
  const gridTopics = useSelector(
    (state) => state.CourseAssignReducer.gridTopics,
    shallowEqual
  );
  const assignments = useSelector(
    (state) => state.CourseAssignReducer.assignments,
    shallowEqual
  );
  const isTopicCollapsed = useSelector(
    (state) => state.CourseAssignReducer.isTopicCollapsed
  );
  const isTopicDirty = useSelector(
    (state) => state.CourseAssignReducer.isTopicDirty
  );

  const [isStandardsCollapsed, setIsStandardsCollapsed] = useState(
    isTopicCollapsed
  );
  const [isStandardDirty, setIsStandardDirty] = useState(isTopicDirty);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isStandardsCollapsed !== isTopicCollapsed) {
      setIsStandardsCollapsed(isTopicCollapsed);
      setIsStandardDirty(false);
    }
  }, [isStandardsCollapsed, isTopicCollapsed]);

  useEffect(() => {
    if (isStandardDirty !== isTopicDirty) {
      setIsStandardDirty(isTopicDirty);
    }
  }, [isStandardDirty, isTopicDirty]);

  useEffect(() => {
    const activities =
      (gridTopics?.length &&
        gridTopics?.map((topic) => {
          const {
            checkedNormal,
            selected,
            coreActivities,
            easierActivities
          } = topic;
          const selectedTopic = checkedNormal
            ? coreActivities
            : easierActivities;
          return selectedTopic && selectedTopic.length && selected
            ? [...selectedTopic, ...(activities?.length ? activities : [])]
            : null;
        })) ||
      [];
    dispatch({
      type: UPDATE_SELECTED_ACTIVITIES,
      activities
    });
  }, [dispatch, gridTopics]);

  if (showGridLoader) {
    return (
      <GridContainer>
        <LoaderContainer>
          <PulseLoader />
        </LoaderContainer>
      </GridContainer>
    );
  }

  if (assignments?.studentAssignments?.length === 0) {
    return (
      <GridContainer>
        <LoaderContainer>
          <EmptyState i18n={props.i18n} />
        </LoaderContainer>
      </GridContainer>
    );
  }

  return (
    <RightSection
      onScroll={(e) => {
        if (document.getElementById('studentList')) {
          document.getElementById('studentList').scrollTop = e.target.scrollTop;
        }
      }}
    >
      <Wrapper id="standards">
        {gridTopics?.length &&
          gridTopics?.map((topic) => {
            const {
              topicId,
              topicName,
              checkedNormal,
              selected,
              coreActivities,
              easierActivities
            } = topic;
            const selectedTopic = checkedNormal
              ? coreActivities
              : easierActivities;
            if (selectedTopic && selectedTopic.length && selected) {
              return (
                <Topic
                  id={topicId}
                  i18n={props.i18n}
                  collapseAllStandards={isStandardsCollapsed}
                  isTopicDirty={isStandardDirty}
                  setIsStandardDirty={setIsStandardDirty}
                  topicName={topicName}
                  activities={selectedTopic}
                  key={topicName}
                />
              );
            }
            return null;
          })}
      </Wrapper>
    </RightSection>
  );
};

Topics.propTypes = {
  i18n: PropTypes.object
};

Topics.defaultProps = {
  gridTopics: []
};

export default Topics;



// WEBPACK FOOTER //
// ./components/topics/index.js